import React from 'react';
import './DailyTimesheetForm.scss';
import { Button } from 'reactstrap';
import { isValid } from './DailyTimesheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeftLong,
    faPaperPlane,
    faSave,
    faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';
import DailyTimesheetRejectButton from './DailyTimesheetRejectButton';

export default class DailyTimesheetActionBar extends React.Component {
    isSaveDisabled = () => {
        const { dailyTimesheet, isAdmin, readOnly, anyChanges } = this.props;

        if (!dailyTimesheet.dailyTimesheetDetails.length || !anyChanges) {
            return true;
        }

        if (!isAdmin) {
            return (
                dailyTimesheet.timesheetStatusId != TimesheetStatus.New &&
                dailyTimesheet.timesheetStatusId != TimesheetStatus.Rejected
            );
        }

        return readOnly;
    };

    isSubmitDisabled = () => {
        const { dailyTimesheet, isAdmin, readOnly } = this.props;

        if (
            !dailyTimesheet.dailyTimesheetDetails.length ||
            !isValid(dailyTimesheet)
        ) {
            return true;
        }

        if (!isAdmin) {
            return (
                dailyTimesheet.timesheetStatusId != TimesheetStatus.New &&
                dailyTimesheet.timesheetStatusId != TimesheetStatus.Rejected
            );
        }

        return readOnly;
    };

    isRejectionAvailable = () => {
        const { dailyTimesheet, isAdmin, isApprover } = this.props;

        if (dailyTimesheet.createdByCurrentUser) {
            return false;
        }

        return (
            (isApprover &&
                dailyTimesheet.timesheetStatusId ==
                    TimesheetStatus.Validated) ||
            (isAdmin &&
                dailyTimesheet.timesheetStatusId == TimesheetStatus.Submitted)
        );
    };

    isAcceptAvailable = () => {
        const { dailyTimesheet, isAdmin, isApprover } = this.props;

        if (dailyTimesheet.createdByCurrentUser) {
            return false;
        }

        return (
            (isApprover &&
                dailyTimesheet.timesheetStatusId < TimesheetStatus.Approved) ||
            (isAdmin &&
                dailyTimesheet.timesheetStatusId < TimesheetStatus.Validated)
        );
    };

    getAcceptVerb = () => {
        const { isAdmin, isApprover } = this.props;

        if (!isAdmin) {
            return null;
        }

        return isApprover ? 'Approve' : 'Validate';
    };

    getAnyTimesheetActionsAvailable = () => {
        const { isAdmin, isApprover, dailyTimesheet, lockedDown } = this.props;

        if (lockedDown) {
            return false;
        }

        if (dailyTimesheet.createdByCurrentUser) {
            return (
                dailyTimesheet.timesheetStatusId == TimesheetStatus.New ||
                dailyTimesheet.timesheetStatusId == TimesheetStatus.Rejected
            );
        }

        if (isApprover) {
            return dailyTimesheet.timesheetStatusId < TimesheetStatus.Approved;
        }

        if (isAdmin) {
            return dailyTimesheet.timesheetStatusId < TimesheetStatus.Validated;
        }

        return false;
    };

    render() {
        const {
            onSaveClick,
            onSubmitClick,
            onBackClick,
            dailyTimesheet,
            onAcceptClick,
        } = this.props;

        const saveDisabled = this.isSaveDisabled();
        const submitDisabled = this.isSubmitDisabled();
        const rejectionAvailable = this.isRejectionAvailable();
        const acceptAvailable = this.isAcceptAvailable();
        const acceptVerb = this.getAcceptVerb();
        const anyTimesheetActionsAvailable =
            this.getAnyTimesheetActionsAvailable();

        return (
            <div className="daily-timesheet-actions">
                <Button
                    type="button"
                    outline={true}
                    color="warning"
                    onClick={onBackClick}
                >
                    <FontAwesomeIcon icon={faArrowLeftLong} className="mr-1" />
                    Back
                </Button>

                {anyTimesheetActionsAvailable && (
                    <>
                        <Button
                            type="button"
                            outline={saveDisabled}
                            disabled={saveDisabled}
                            onClick={onSaveClick}
                        >
                            <FontAwesomeIcon icon={faSave} className="mr-1" />{' '}
                            Save
                        </Button>

                        {dailyTimesheet.createdByCurrentUser && (
                            <Button
                                type="button"
                                outline={submitDisabled}
                                disabled={submitDisabled}
                                onClick={onSubmitClick}
                                color="success"
                            >
                                <FontAwesomeIcon
                                    icon={faPaperPlane}
                                    className="mr-1"
                                />{' '}
                                Submit
                            </Button>
                        )}

                        {rejectionAvailable && (
                            <DailyTimesheetRejectButton {...this.props} />
                        )}

                        {acceptAvailable && (
                            <Button
                                type="button"
                                color="success"
                                onClick={onAcceptClick}
                                outline={!isValid(dailyTimesheet)}
                                disabled={!isValid(dailyTimesheet)}
                            >
                                <FontAwesomeIcon
                                    icon={faThumbsUp}
                                    className="mr-1"
                                />
                                {acceptVerb}
                            </Button>
                        )}
                    </>
                )}
            </div>
        );
    }
}
